import { defineMessages } from 'react-intl';

export default defineMessages({
    boatMonetaryValue: {
        "id": "wmic-pe-capability-gateway-common-ho-react.WMICHOBoatDetails.Value",
        "defaultMessage": "Value"
    }
});
